<template>
	<svg :width="width" :height="height" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
		<path :fill="color" d="M12 2L7.5 8.5H9.8L6 14.5H10.2L12 18L13.8 14.5H18L14.2 8.5H16.5L12 2Z"></path>
		<rect :fill="color" x="11" y="18" width="2" height="4"></rect>
	</svg>
</template>

<script>
export default {
	name: 'GardenIcon',
	props: {
		width: {
			type: Number,
			default: 32,
		},
		height: {
			type: Number,
			default: 32,
		},
		color: {
			type: String,
			default: 'black',
		},
	},
}
</script>
